import React, { useState } from 'react';
import { Alert, Avatar, Box, Button, CircularProgress, Grid, Paper, Snackbar, TextField, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import { loginWithCredentials } from '../api/authApi';
import { persistSession } from '../../../shared/auth/session';

export default function LoginForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [openGood, setOpenGood] = useState(false);
  const [openBad, setOpenBad] = useState(false);
  const [openBaja, setOpenBaja] = useState(false);
  const [inactiveMessage, setInactiveMessage] = useState('Tu cuenta no esta habilitada todavia. Debe ser activada por un administrador.');

  const redirectAfterLogin = (isAdmin) => {
    navigate(isAdmin ? '/homeAdmin' : '/home');
  };

  const handleSuccessfulLogin = (responseData) => {
    persistSession({ token: responseData.token, userId: responseData.id });
    setOpenGood(true);
    redirectAfterLogin(responseData.is_admin === true);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await loginWithCredentials({ email, password });
      handleSuccessfulLogin(response.data);
    } catch (error) {
      if (error?.response?.status === 403) {
        setInactiveMessage(error.response.data?.message || 'Tu cuenta no esta habilitada todavia. Debe ser activada por un administrador.');
        setOpenBaja(true);
      } else {
        setOpenBad(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Paper elevation={20} sx={{ p: 2, width: 400 }}>
        <Grid align="center">
          <Avatar sx={{ bgcolor: '#0D6AEE' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant="h5">Iniciar Sesion</Typography>
        </Grid>

        <form onSubmit={handleLogin}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Correo electronico" type="email" required fullWidth value={email} onChange={(event) => setEmail(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Contrasena" type="password" required fullWidth value={password} onChange={(event) => setPassword(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth sx={{ bgcolor: '#0D6AEE' }} disabled={loading}>
                {loading ? <CircularProgress size={22} color="inherit" /> : 'Iniciar sesion'}
              </Button>
            </Grid>
          </Grid>
        </form>

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success">Inicio de sesion exitoso.</Alert>
        </Snackbar>
        <Snackbar open={openBad} autoHideDuration={2000} onClose={() => setOpenBad(false)}>
          <Alert severity="error">Usuario o contrasena incorrectos.</Alert>
        </Snackbar>
        <Snackbar open={openBaja} autoHideDuration={2000} onClose={() => setOpenBaja(false)}>
          <Alert severity="warning">{inactiveMessage}</Alert>
        </Snackbar>
      </Paper>
    </Box>
  );
}
